import React, { useState, useRef,useCallback, useMemo,useLayoutEffect,useEffect } from "react";
import { Resizable } from 'react-resizable'; 
import { useNavigate } from 'react-router-dom';
import {
  Table,
  Button,
  Row,
  Col,
  Card,
  Breadcrumb,
  Badge,
  Select,
  Divider,
  Form,
  DatePicker,
  Dropdown,
  Menu,
  Alert,
  Empty,
  notification,
  Space,
  Flex
} from "antd";
import {
  HomeOutlined,
  EllipsisOutlined,
  DownOutlined,
  FilePdfOutlined,
  FileExcelOutlined
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import ViewDocument from './View';
import StatusTrial from './StatusTrial';
import ShareDocument from './ShareDocument'
import dayjs from "dayjs";
import AccountPayableAPI from "../../../restAPI/AccountPayableAPI";
import ReportAPI from "../../../restAPI/ReportAPI"
import { useSelector } from 'react-redux';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import documentManagementAPI from '../../../restAPI/DocumentManagement';
import JSZip from "jszip";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

const selfBilledTypes = [
  "Self-billed Invoice",
  "Self-billed Credit Note",
  "Self-billed Debit Note",
  "Self-billed Refund Note"
];


const { Option } = Select;
const ResizableTitle = (props) => {
  const { onResize, width, children, ...restProps } = props;
  if (!width) return <th {...restProps}>{children}</th>;

  return (
    <th {...restProps}>
      <Resizable
        width={width}
        height={0}
        onResize={onResize}
        draggableOpts={{ enableUserSelectHack: false }}
        handle={
          <span
            style={{
              position: "absolute",
              right: 0,
              bottom: 0,
              cursor: "col-resize",
              width: "2px",
              height: "100%",
              background: "#ffeb3b3b",
            }}
          />
        }
      >
        <div>{children}</div>
      </Resizable>
    </th>
  );
};

export default function UserTable() {
  const tableContainerRef = useRef();
  const notificationShown = useRef(false);
  const viewDocumentRef = useRef(null);
  const statusTrialRef = useRef(null);
  const shareDocumentRef = useRef(null);
  const [searchform] = Form.useForm(); // form instance for the form
   const { token } = useSelector(state => state.auth); //get the token
  const [allDocumentTypes,setAllDocumentTypes] = useState([]); //for document Types
  const [accountSearchData, setAccountSearchData] = useState([]); // to store the sorted data
  const [accountAllData,setAccountAllData] = useState([]);// to initially hold the all the documents wothout sorting
  const dateFormat = 'YYYY/MM/DD';
   const isInitialRender = useRef(true); // to skip running on initial render the GetDataforTotalTaxAmountReport() method
  const [supplierDetails,setSupplierDetails] = useState([]);
  const [buyerDetails,setBuyerDetails] = useState([]);
  const [formatTypeDetails, setFormatTypeDetails] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isShareBtnDisable, setIsShareBtnDisable] = useState(false);

// Extend dayjs with the plugins
//The extend() method in Day.js is used to enable a plugin (like isSameOrAfter) by adding it to the Day.js core.
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

    const [api,contextHolder] = notification.useNotification();

    const openNotificationWithIcon = (type, message, description, placement) => {
      if (!notificationShown.current) {
        notification[type]({
          message: message,
          description: description,
          placement,
        });
        notificationShown.current = true;
        setTimeout(() => {
          notificationShown.current = false;
        }, 5000);
      }
    };

    // Download functionality
    const handleBulkDownloadAndZip = async () => {
      if (selectedRows.length === 0) {
        openNotificationWithIcon(
          "error",
          "No Documents Selected",
          "Please select documents to download.",
          "bottomLeft"
        );
        return;
      }

      const zip = new JSZip();
      const failedDownloads = [];

      for (const record of selectedRows) {
        try {
          // Create a FormData object
          const formData = new FormData();
          formData.append("groupId", localStorage.getItem("groupId"));
          formData.append("companyId", localStorage.getItem("companyId"));
          formData.append("fileUrl", record.originalFilePath);
          formData.append("MOGU_UUID", record.documentMoguID);
          formData.append("TPS_Id", record.tPS_Id);

          // Pass the FormData object to the API
          const response = await documentManagementAPI.downloadDocumentWithQRCodeZip(token, formData);

          const blob = new Blob([response.data], { type: "application/pdf" });
          zip.file(`${record.invoiceNumber || "Document"}.pdf`, blob);
        } catch (err) {
          console.error(`Failed to download PDF for ${record.invoiceNumber}:`, err);
          failedDownloads.push(record.invoiceNumber || "Unknown Document");
        }
      }

      // Calculate success and failed counts
      const totalSelected = selectedRows.length;
      const successCount = Object.keys(zip.files).length;
      const failedCount = failedDownloads.length;

      if (failedCount > 0) {
        openNotificationWithIcon(
          "warning",
          "Download Partially Completed",
          `Download Summary: ${successCount} documents downloaded successfully, ${failedCount} documents failed to download.`,
          "bottomLeft"
        );
      }

      if (successCount > 0) {
        const zipBlob = await zip.generateAsync({ type: "blob" });
        saveAs(zipBlob, "Documents.zip");
        
        if (failedCount === 0) {
          openNotificationWithIcon(
            "success",
            "Download Complete",
            `All ${successCount} documents have been downloaded successfully.`,
            "bottomLeft"
          );
        }
      }
    };

    const menuItems = [
      {
        label: "Excel",
        key: "1",
        icon: <FileExcelOutlined />,
        onClick: async () => {
          // Define the headings for the Excel file
          const headings = [
            [
              "Key",
              "Document Mogu ID",
              "Invoice Number",
              "Transaction Type",
              "Document Type",
              "Upload Date",
              "Uploaded By",
              "Supplier Name",
              "Buyer Name",
              "Status",
              "Original File Path",
              "Total Excluding Tax",
              "Total Including Tax",
              "Format Type",
              "Is Active",
              "Is Duplicate",
              "Is Tax Mismatch",
              "Is Required Trading Partner Company Code Missing",
              "TPS ID"
            ],
          ];

          try {
            // Ensure selectedRows is an array
            const rows = Array.isArray(selectedRows) ? selectedRows : [];

            // Map the selectedRows data to match the headings
            const data = rows.map((rowValue) => [
              rowValue.key || "",
              rowValue.documentMoguID || "",
              rowValue.invoiceNumber || "N/A",
              rowValue.transactionType || "N/A",
              rowValue.documentType || "N/A",
              rowValue.uploadDate || "N/A",
              rowValue.uploadedBy || "N/A",
              // Apply the same conditional logic as the table display for self-billed types
              selfBilledTypes.includes(rowValue.documentType) 
                ? (rowValue.buyerName || "N/A")    // Show buyer as supplier for self-billed
                : (rowValue.supplierName || "N/A"), // Show supplier normally
              selfBilledTypes.includes(rowValue.documentType)
                ? (rowValue.supplierName || "N/A")  // Show supplier as buyer for self-billed  
                : (rowValue.buyerName || "N/A"),    // Show buyer normally
              rowValue.status || "N/A",
              rowValue.originalFilePath || "N/A",
              rowValue.totalExcludingTax || "N/A",
              rowValue.totalIncludingTax || "N/A",
              rowValue.formatType || "Unknown",
              rowValue.isActive || "",
              rowValue.isDuplicate || "",
              rowValue.isTaxMismatch || "",
              rowValue.isRequiredTPCompanyCodeMissing || "",
              rowValue.tPS_Id || ""
            ]);

            // Combine headings and data
            const worksheetData = [...headings, ...data];

            // Create a worksheet
            const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

            // Create a workbook and append the worksheet
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Selected Records");

            // Generate and download the Excel file
            XLSX.writeFile(workbook, "SelectedRecords.xlsx");
          } catch (error) {
            console.error("Error generating Excel file:", error);
            openNotificationWithIcon(
              "error",
              "Excel Generation Failed",
              "An error occurred while generating the Excel file.",
              "bottomLeft"
            );
          }
        },
      },
      {
        label: "PDF",
        key: "2",
        icon: <FilePdfOutlined />,
        onClick: () => {
          handleBulkDownloadAndZip();
        },
      },
      {
        label: "JSON",
        key: "3",
        icon: <FilePdfOutlined />, // Replace with a JSON icon if available
        onClick: async () => {
          try {
            // Ensure selectedRows is an array
            const rows = Array.isArray(selectedRows) ? selectedRows : [];

            // Map the selectedRows data to match the fields
            const jsonData = rows.map((rowValue) => ({
              Key: rowValue.key || "",
              "Document Mogu ID": rowValue.documentMoguID || "",
              "Uploaded User ID": rowValue.uploadedUserId || "",
              "Invoice Number": rowValue.invoiceNumber || "N/A",
              "Transaction Type": rowValue.transactionType || "N/A",
              "Document Type": rowValue.documentType || "N/A",
              "Upload Date": rowValue.uploadDate || "N/A",
              "Uploaded By": rowValue.uploadedBy || "N/A",
              "Supplier Name": selfBilledTypes.includes(rowValue.documentType) 
                ? (rowValue.buyerName || "N/A")    // Show buyer as supplier for self-billed
                : (rowValue.supplierName || "N/A"), // Show supplier normally
              "Buyer Name": selfBilledTypes.includes(rowValue.documentType)
                ? (rowValue.supplierName || "N/A")  // Show supplier as buyer for self-billed  
                : (rowValue.buyerName || "N/A"),    // Show buyer normally
              Status: rowValue.status || "N/A",
              "Original File Path": rowValue.originalFilePath || "N/A",
              "Total Excluding Tax": rowValue.totalExcludingTax && rowValue.totalExcludingTax !== "N/A" && rowValue.totalExcludingTax !== "NaN" 
                ? Number(rowValue.totalExcludingTax).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                : "N/A",
              "Total Including Tax": rowValue.totalIncludingTax && rowValue.totalIncludingTax !== "N/A" && rowValue.totalIncludingTax !== "NaN"
                ? Number(rowValue.totalIncludingTax).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                : "N/A",
              "Is Active": rowValue.isActive || "",
              "Is Duplicate": rowValue.isDuplicate || "",
              "Is Tax Mismatch": rowValue.isTaxMismatch || "",
              "Is Required Trading Partner Company Code Missing": rowValue.isRequiredTPCompanyCodeMissing || "",
              "TPS ID": rowValue.tPS_Id || ""
            }));

            // Convert JSON data to a Blob
            const jsonBlob = new Blob([JSON.stringify(jsonData, null, 2)], { type: "application/json" });

            // Create a download link
            const link = document.createElement("a");
            link.href = URL.createObjectURL(jsonBlob);
            link.download = "SelectedRecords.json";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } catch (error) {
            console.error("Error generating JSON file:", error);
            openNotificationWithIcon(
              "error",
              "JSON Generation Failed",
              "An error occurred while generating the JSON file.",
              "bottomLeft"
            );
          }
        },
      },
    ];

    // Handle selection change
    const handleSelectChange = (selectedKeys, selectedRows) => {
      setSelectedRows(selectedRows);
      setSelectedRowKeys(selectedKeys);
      
      // Enable share button if any selected records have 'success' status
      if (selectedRows.length > 0) {
        const hasSuccessRecords = selectedRows.some(item => item.status.toLowerCase().includes('success'));
        setIsShareBtnDisable(hasSuccessRecords);
      } else {
        setIsShareBtnDisable(false);
      }
    };

  const viewDocumentDrawer = (record) => {
    viewDocumentRef.current.openDrawer(record);
  };
  const statusTrialDrawer = (record) => {
    statusTrialRef.current.openDrawer(record);
  };

  const shareDocumentDrawer = (record = null) => {
    if (record != null) {
      shareDocumentRef.current.openDrawer(record);
    } else {
      // For bulk share, pass all selected records
      if (selectedRows.length > 0) {
        shareDocumentRef.current.openDrawer(selectedRows);
      }
    }
  };

  const home = () => {
    navigate('/dashboard');
  };

  const handleFormClear = () => {
   // formRef.current.resetFields();
   searchform.resetFields();
   setAccountSearchData(accountAllData);
  };

  const getStatusColor = (status) => ({
    uploaded: '#008080',
    pending: '#ffff00',
    extracted: '#FDC483',
    'failed submittable': '#FCA746',
    submitted: '#1890ff',
    success: '#52c41a',
    failed: '#ff0000',
    deleted: '#888',
    canceled: '#800080',
    'failed validation':'#008b8b',
    duplicate: '#ff69b4',
    'on hold': '#FF8C00',
    'onhold': '#FF8C00',
  })[status.toLowerCase()] || '#d9d9d9'; // default color if status not found

  const initialColumns = [
    {
      title: "Invoice Number",
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
      sorter: (a, b) => a.invoiceNumber.localeCompare(b.invoiceNumber),
      percentageWidth: 0.15,
    },
    {
      title: "Transaction Type",
      dataIndex: "transactionType",
      key: "transactionType",
      sorter: (a, b) => a.transactionType.localeCompare(b.transactionType),
      percentageWidth: 0.15,
    },
    { 
      title: "Document Type",
      dataIndex: "documentType",
      key: "documentType",
      sorter: (a, b) => a.documentType.localeCompare(b.documentType),
      percentageWidth: 0.15,
    },
    {
      title: "Current Status",
      dataIndex: "status",
      percentageWidth: 0.15,
      key: "status",
      sorter: (a, b) => a.status.localeCompare(b.status),
      render: (status) => (
         <Badge
                    color={getStatusColor(status)}
                    // status={
                    //   status.toLowerCase() === "extracted"
                    //     ? "processing"
                    //     : status.toLowerCase() === "success"
                    //     ? "success"
                    //     : "default"
                    // }
                    text={status.charAt(0).toUpperCase() + status.slice(1)}
        />
      ),
    },
    {
      title: "Supplier Name",
      dataIndex: "supplierName",
      percentageWidth: 0.15,
      key: "supplierName",
      sorter: (a, b) => a.supplierName.localeCompare(b.supplierName),
      render: (_, record) => 
        record.transactionType === "Accounts payable" ? record.buyerName : record.supplierName,
    },
    {
      title: "Buyer Name",
      dataIndex: "buyerName",
      percentageWidth: 0.15,
      key: "buyerName",
      sorter: (a, b) => a.buyerName.localeCompare(b.buyerName),
      render: (_, record) => 
        record.transactionType === "Accounts payable" ? record.supplierName : record.buyerName,
    },
    {
      title: "Total Excluding Tax",
      dataIndex: "totalExcludingTax",
      percentageWidth: 0.15,
      key: "totalExcludingTax",
      render: (price) => price !== "N/A" && price !=="NaN" ? Number(price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "N/A"
      //sorter: (a, b) => new Date(a.uploadDate) - new Date(b.uploadDate),
    },
    {
      title: "Total Including Tax",
      dataIndex: "totalIncludingTax",
      percentageWidth: 0.15,
      key: "totalIncludingTax",
      render: (price) => price !== "N/A" && price !=="NaN" ? Number(price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "N/A"
      //sorter: (a, b) => a.uploadedBy.localeCompare(b.uploadedBy),
    },
    {
      title: "Format Type",
      dataIndex: "formatType",
      key: "formatType",
      percentageWidth: 0.10,
      sorter: (a, b) => a.formatType.localeCompare(b.formatType),
      render: (formatType) => (
        <Badge 
          color={formatType === 'PDF' ? 'red' : formatType === 'Excel' ? 'green' : 'default'}
          text={formatType || 'Unknown'}
        />
      ),
    },
    {
      title: "Action",
      key: "action",
      percentageWidth: 0.10,
      render: (_, record) => {
        const menuItems = [

         (record.status.toLowerCase() === "success") ? { key: "view", label: "View", onClick: ()=>{viewDocumentDrawer(record)}} : null,
         (record.status.toLowerCase() === "success") ? { key: "share", label: "Share", onClick: ()=>{shareDocumentDrawer(record)}} : null,
          { key: "status Trail", label: "Status Trail", onClick: ()=>{statusTrialDrawer(record)}, },

        ].filter(item => item != null); // removes null and undefined)


        return (
          <Dropdown
            overlay={
              <Menu>
                {menuItems.map((item) => (
                  <Menu.Item
                    key={item.key}
                    onClick={item.onClick} // Add the onClick handler here
                  >
                    {item.link ? (
                      <Link to={item.link}>{item.label}</Link> // If a link is provided, render it
                    ) : (
                      item.label // Otherwise, just render the label
                    )}
                  </Menu.Item>
                ))}
              </Menu>
            }
            trigger={["click"]}
          >
            <Button type="primary" icon={<EllipsisOutlined />} />
          </Dropdown>
        );
      },
    },
  ];
  const navigate = useNavigate();
      // Compute an initial container width using window.innerWidth as fallback.
      const initialContainerWidth = typeof window !== 'undefined' ? window.innerWidth : 1200;

      // Set initial column widths based on the fallback container width.
      const [columns, setColumns] = useState(
        initialColumns.map(col => ({
          ...col,
          width: Math.floor(initialContainerWidth * col.percentageWidth),
        }))
      );
    
      // Function to update column widths based on the measured container.
      const updateColumnWidths = useCallback(() => {
        if (tableContainerRef.current) {
          const containerWidth = tableContainerRef.current.offsetWidth;
          setColumns(initialColumns.map(col => ({
            ...col,
            width: Math.floor(containerWidth * col.percentageWidth),
          })));
        }
      }, [initialColumns]);
    
      // Use useLayoutEffect to update column widths as soon as the component is mounted.
      useLayoutEffect(() => {
        updateColumnWidths();
      }, [updateColumnWidths]);
    
      // Update widths on window resize.
      useEffect(() => {
        window.addEventListener('resize', updateColumnWidths);
        return () => window.removeEventListener('resize', updateColumnWidths);
      }, [updateColumnWidths]);

      useEffect(()=>{
        // console.log("GroupId :",localStorage.getItem('groupId'));
        // console.log("CompanyId :",localStorage.getItem('companyId'));
        if (token !== null) {
        GetDocumentTypes();
        getSupplierInformation();
        getBuyerInformation();
        }
      },[])
        useEffect(()=>{
          if(isInitialRender.current){
            isInitialRender.current = false;
            return;
          }
          GetDataforDocumentSumeryReport(); // load all the invoice types after you load the invoice types
        },[allDocumentTypes])
    
    
    const handleResize = useCallback(
        (index) => (e, { size }) => {
          setColumns((prevColumns) => {
            const newColumns = [...prevColumns];
            newColumns[index] = { ...newColumns[index], width: size.width };
            return newColumns;
          });
        },
        []
      );
      
      const mergedColumns = useMemo(
        () =>
          columns.map((col, index) => ({
            ...col,
            onHeaderCell: (column) => ({
              width: column.width,
              onResize: handleResize(index),
            }),
          })),
        [columns, handleResize]
      );

  //----------------------------------------------------------API Calls finctions--------------------------------------------------
    const GetDocumentTypes = async () =>
    {
      await AccountPayableAPI.GetDocumentTypes(token, localStorage.getItem('groupId'),localStorage.getItem('companyId'))
            .then((res) => {
               if (res?.data) {
                         //console.log(JSON.stringify(res.data));
                         const documetTypes = res.data.map((rowValue) =>  ({
                               value: rowValue.description,
                               code: rowValue.code,
                               label: rowValue.description
                          })).sort((a, b) => a.label.localeCompare(b.label));
                          
                          //let selectedDocumentTypes = documetTypes.filter(type => ["Self-billed Credit Note","Self-billed Debit Note","Self-billed Refund Note","Self-billed Invoice"].includes(type.label));
                          //let selectedDocumentTypes = documetTypes.unshift({label:"All",value:"00"});
                          setAllDocumentTypes(documetTypes);
                          //console.log("shifted documents ",selectedDocumentTypes);//Self-billed Credit Note, Self-billed Debit Note, Self-billed Refund, and Self-billed Invoice
                      }
            })
            .catch((err) => {
                if (err.response) {
                    openNotificationWithIcon('error', 'No Document Type found', `${err.response.data.message}`, 'bottomLeft');
                } else {
                    openNotificationWithIcon('error', 'No Document Type found', `${err.message}`, 'bottomLeft');
                }
            });
    }

      const GetDataforDocumentSumeryReport = async () =>
      {
     // comment this when checking
     //const companyId = "6787e74b5035b0a86e7793c5";
      if(localStorage.getItem('companyId') !==null)
      {
        await ReportAPI.GetDataforDocumentSumeryReport(token, localStorage.getItem('groupId'), localStorage.getItem('companyId'))
              .then((res) => {
                 if (res?.data) {
                            const rows = [];
                            let tempKey = 0;
                            res.data.map((rowValue) =>  {
                              let statusValue = null;
                              let documentCategory = allDocumentTypes.filter((type) => type.code == rowValue?.invoiceType)[0];
                              // console.log("Document Catogory :- "+ JSON.stringify(documentCategory));
                              if(rowValue.status){
                                statusValue = "Active"
                              }
                              else{
                                statusValue = "Inactive"
                              }
                              rows.push({//key: rowValue?.documentMoguID,
                                key: tempKey++,
                                documentMoguID: rowValue?.documentMoguID,
                                uploadedUserId: rowValue?.uploadedUserId,
                                invoiceNumber:(!rowValue?.invoiceNumber|| rowValue?.invoiceNumber.trim() === "")?"N/A":rowValue?.invoiceNumber,
                                documentType: (!documentCategory?.label||documentCategory?.label.trim()==="") ? "N/A" : documentCategory?.label,
                                transactionType : (!rowValue?.documentType|| rowValue?.documentType.trim() === "")?"N/A":rowValue?.documentType,
                                //classification:  rowValue?.classification.trim()  === "" ? "N/A" : rowValue?.classification, //this is an array normally include only 1 value change in future
                                uploadDate: dayjs(rowValue.uploadedDateAndTime).format('YYYY-MM-DD HH:mm:ss'),
                                uploadedBy:rowValue.uploadedUserId,
                                supplierName :(!rowValue.supplierName||rowValue.supplierName.trim()==="") ? "N/A" : rowValue.supplierName,
                                buyerName: (!rowValue.BuyerName || rowValue.BuyerName.trim()==="") ? "N/A":rowValue.BuyerName,
                                status: rowValue?.status,
                                originalFilePath: rowValue?.originalFilePath,
                                totalIncludingTax: !rowValue?.totalIncludingTax || (String(rowValue?.totalIncludingTax).trim() == "") ? "N/A" : rowValue.totalIncludingTax,
                                totalExcludingTax: !rowValue?.totalExcludingTax || (String(rowValue?.totalExcludingTax).trim() ==="")? "N/A": rowValue.totalExcludingTax,
                                isActive:rowValue?.isActive,
                                isDuplicate:rowValue?.isDuplicate,  
                                isTaxMismatch:rowValue?.isTaxMismatch,
                                isRequiredTPCompanyCodeMissing:rowValue?.isRequiredTPCompanyCodeMissing,
                                tPS_Id:rowValue?.TPS_Id,
                                formatType:rowValue?.formatType || "Unknown",
                              })
                            });
                            setAccountAllData(rows);
                            setAccountSearchData(rows);
                        }
              })
              .catch((err) => {
                  if (err.response) {
                      openNotificationWithIcon('error', 'No data found', `${err.response.data.message}`, 'bottomLeft');
                  } else {
                      openNotificationWithIcon('error', 'No data found', `${err.message}`, 'bottomLeft');
                  }
              });
        }
        else{
            openNotificationWithIcon('info', 'Information', "Please select a Group and Company.", 'bottomLeft');
        }
      }


    const getSupplierInformation = async () =>
      {

      if(localStorage.getItem('companyId') !==null)
      {
        await ReportAPI.getSupplierInformation(token, localStorage.getItem('groupId'),localStorage.getItem('companyId'))
        .then((res) => {
           if (res?.data) {
                     //console.log(JSON.stringify(res.data));
                     const supplierTypes = res.data.map((rowValue) =>  ({
                           value: rowValue._id,
                           //code: rowValue.code,
                           label: rowValue.name
                      })).sort((a, b) => a.label.localeCompare(b.label));
                      
                      //let selectedDocumentTypes = documetTypes.filter(type => ["Self-billed Credit Note","Self-billed Debit Note","Self-billed Refund Note","Self-billed Invoice"].includes(type.label));
                      supplierTypes.unshift({label:"All",value:"all"});
                      setSupplierDetails(supplierTypes);
                      //console.log("shifted documents ",selectedDocumentTypes);//Self-billed Credit Note, Self-billed Debit Note, Self-billed Refund, and Self-billed Invoice
                  }
        })
        .catch((err) => {
            if (err.response) {
                openNotificationWithIcon('error', 'No Supplier Details found', `${err.response.data.message}`, 'bottomLeft');
            } else {
                openNotificationWithIcon('error', 'No Supplier Details found', `${err.message}`, 'bottomLeft');
            }
        });

      }
      else{
            openNotificationWithIcon('info', 'Information', "Please select a Group and Company.", 'bottomLeft');
      }
    }

      const getBuyerInformation = async ()=>
      {
        
        if(localStorage.getItem('companyId') !==null)
        {
            await ReportAPI.getBuyerInformation(token, localStorage.getItem('groupId'),localStorage.getItem('companyId'))
            .then((res) => {
              if (res?.data) {
                        //console.log(JSON.stringify(res.data));
                        const buyerTypes = res.data.map((rowValue) =>  ({
                              value: rowValue._id,
                              //code: rowValue.code,
                              label: rowValue.tradingPartnerName
                          })).sort((a, b) => a.label.localeCompare(b.label));
                          
                          //let selectedDocumentTypes = documetTypes.filter(type => ["Self-billed Credit Note","Self-billed Debit Note","Self-billed Refund Note","Self-billed Invoice"].includes(type.label));
                          buyerTypes.unshift({label:"All",value:"all"});
                          setBuyerDetails(buyerTypes);
                          //console.log("shifted documents ",selectedDocumentTypes);//Self-billed Credit Note, Self-billed Debit Note, Self-billed Refund, and Self-billed Invoice
                      }
            })
            .catch((err) => {
                if (err.response) {
                    openNotificationWithIcon('error', 'No Buyer Details found', `${err.response.data.message}`, 'bottomLeft');
                } else {
                    openNotificationWithIcon('error', 'No Buyer Details found', `${err.message}`, 'bottomLeft');
                }
            });
        }
        else{
              setBuyerDetails([]);
              openNotificationWithIcon('info', 'Information', "Please select a Group and Company.", 'bottomLeft');
        }
      }
    
      
  //-------------------------------------------------------------End of API calls---------------------------------------------------

  //-------------------------------------------------------Form Controls-------------------------------------------------------------
  const onFinish = (values) => {
    //message.success('Form submitted successfully!');
    let fromDate = dayjs(values.fromDate);//.format("YYYY-MM-DD HH:mm:ss");
    let toDate = dayjs(values.toDate);//.format("YYYY-MM-DD HH:mm:ss");
    //console.log('from date:', fromDate);
    //console.log('To date:', toDate);

    // let filtered = accountAllData.filter(element => dayjs(element.uploadDate) >= fromDate
    //                                      && dayjs(element.uploadDate) <= toDate);

    let filtered = accountAllData.filter(element => {
    const uploadDate = dayjs(element.uploadDate).startOf('day'); //startOf('day') sets the time to 00:00:00, effectively isolating just the date.
    return uploadDate.isSameOrAfter(fromDate.startOf('day')) && uploadDate.isSameOrBefore(toDate.endOf('day'));
  });
  
  if(values.transactiontype|| (values.transactiontype?.trim()||"") !== "")
    {
      filtered = filtered.filter(element => values.transactiontype === "all" || element.transactionType === values.transactiontype);
    }
    //console.log("after Transaction Types",JSON.stringify(filtered));
    //This must be change in future if document type and classification should be compulsry for search 
    if(values.documentType && (values.documentType?.trim()||"") !== "00" && (values.documentType?.trim()||"") !== "")
      {
        filtered = filtered.filter(element => element.documentType === values.documentType);
      }
    if(values.status && values.status.length > 0)
      {
        filtered = filtered.filter(element => {
          // Check if "All" is selected - if so, include all records
          if (values.status.includes("all")) {
            return true;
          }
          // Check if the element's status matches any of the selected statuses
          return values.status.some(selectedStatus => {
            return element.status.toLowerCase() === selectedStatus.toLowerCase();
          });
        });
      }
    if(values.supplierName && (values.supplierName?.trim()||"") !== "" && (values.supplierName?.trim()||"") !== "all")
      {
        let supplierObj = supplierDetails.find(item => item.value === values.supplierName);
        filtered = filtered.filter(element =>  element.supplierName.toLowerCase() === supplierObj.label.toLowerCase());
      }
    if(values.buyerName && values.buyerName.length > 0)
    {
      filtered = filtered.filter(element => {
        // Check if "All" is selected - if so, include all records
        if (values.buyerName.includes("all")) {
          return true;
        }
        
        let cleanBuyerName = element.buyerName.replace(/([.+^=!:${}()|\[\]\/\\])/g, '').trim().toLowerCase();
        
        // Check if the element's buyer name matches any of the selected buyer names
        return values.buyerName.some(buyerName => {
          let buyerObj = buyerDetails.find(item => item.value === buyerName);
          if (buyerObj) {
            let cleanUserInput = buyerObj.label.replace(/([.+^=!:${}()|\[\]\/\\])/g, '').trim().toLowerCase();
            const regex = new RegExp(cleanUserInput, 'i');
            return regex.test(cleanBuyerName);
          }
          return false;
        });
      });
    }
    if(values.formatType && values.formatType.length > 0)
      {
        filtered = filtered.filter(element => {
          // Check if "All" is selected - if so, include all records
          if (values.formatType.includes("all")) {
            return true;
          }
          // Check if the element's format type matches any of the selected format types
          return values.formatType.some(selectedFormatType => {
            return element.formatType === selectedFormatType;
          });
        });
      }

      setAccountSearchData(filtered);
      //console.log("Filterd List");
      //console.log(filtered);
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Validation Failed:', errorInfo);
    //message.error('Please check the form for errors.');
  };

  const onFromDateChange = (date, dateString) => {
    console.log("date :",date);
    console.log("dateString :",dateString);
  }
  const onToDateChange = (date, dateString) => {
    console.log("date :",date);
    console.log("dateString :",dateString);
  }

   const disabledFutureDate = (current) => {
      return current && current > dayjs().endOf("day");
    }
  //-----------------------------------------------------------Rnd of Forms------------------------------------------------
  return (
    <Row>
       {contextHolder}
      <Col md={24}>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item href="/dashboard">
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            Report
          </Breadcrumb.Item>
          <Breadcrumb.Item>Document Summary Report</Breadcrumb.Item>
        </Breadcrumb>
        <div className="border-container">
          <Button
            type="primary"
            variant="dashed"
            className="card-button"
            size="large"
            icon={<HomeOutlined />}
            onClick={home}
            shape="circle"
          />
          <Card title="Document Summary Report" bordered={true}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Form
                form={searchform}
                //ref={formRef}
                layout="vertical"
                style={{
                  width: "75%",
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={{fromDate:new dayjs(),toDate : new dayjs(),transactiontype:"all",documentType:"00"}}
              >
                <Row gutter={24}>
               
                  <Col lg={8} md={24} sm={24} xs={24} >
                    <Form.Item
                      label="From Date"
                      name="fromDate"
                      rules={[
                        {
                          required: true,
                          message: "Please select From Date!",
                        },
                      ]}
                    >
                      <DatePicker
                      onChange={onFromDateChange}  value={new dayjs(dateFormat)}
                      size="large" style={{ width: "100%" }} disabledDate={disabledFutureDate} format={dateFormat}/>
                    </Form.Item>
                  </Col>
                  <Col lg={8} md={24} sm={24} xs={24}>
                    <Form.Item
                      label="To Date"
                      name="toDate"
                      rules={[
                        { required: true, message: "Please select To Date!" },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            //Apply validation only if "item1" is selected
                            if (dayjs(value).diff(dayjs(getFieldValue('fromDate')),'days') < 0 || !value) {
                              return Promise.reject(new Error('Invalid Date Selection!'));
                              
                            }
                            return Promise.resolve();
                          },
                        })
                      ]}
                    >
                      <DatePicker  onChange={onToDateChange }
                      size="large" style={{ width: "100%" }}  disabledDate={disabledFutureDate} format={dateFormat}/>
                    </Form.Item>
                  </Col>
                  <Col lg={8} md={24} sm={24} xs={24}>
                    <Form.Item
                      label="Transaction Type"
                      name="transactiontype"
                      rules={[
                        {
                          required: true,
                          message: "Please select a Transaction Type!",
                        },
                      ]}
                    >
                      <Select size="large" placeholder="All">
                        <Option value="all">All</Option>
                        <Option value="Accounts receivable">Accounts Receivables</Option>
                        <Option value="Accounts payable">Accounts Payables</Option>

                      </Select>
                    </Form.Item>
                  </Col>
                  <Col lg={8} md={24} sm={24} xs={24}>
                    <Form.Item
                      label="Document Type"
                      name="documentType"
                      rules={[
                        {
                          required: true,
                          message: "Please select a Document Type!",
                        },
                      ]}
                    >
                      <Select size="large" placeholder="Please select a Document Type"  options={allDocumentTypes}>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col lg={8} md={24} sm={24} xs={24}>
                    <Form.Item label="Supplier Name" name="supplierName">
                      <Select size="large" placeholder="All" showSearch
                       optionFilterProp="label"
                       filterSort={(optionA, optionB) => {
                        const labelA = optionA?.label?.toLowerCase() ?? '';
                        const labelB = optionB?.label?.toLowerCase() ?? '';
                        return labelA.localeCompare(labelB);
                       }}
                       options={supplierDetails}>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col lg={8} md={24} sm={24} xs={24}>
                    <Form.Item label="Buyer Name" name="buyerName">
                      <Select
                        mode="multiple"
                        name="buyerName"
                        showSearch
                        options={buyerDetails}
                        size="large"
                        placeholder="Select Multiple Buyers"
                        listHeight={200}
                        maxTagCount="responsive"
                        allowClear
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          (option?.label ?? "").toString().toLowerCase().includes(input.toLowerCase())
                        }
                        optionRender={(option) => (
                          <div style={{ whiteSpace: "normal", lineHeight: "1.2em", overflowWrap: "break-word" }}>
                            {option.data.label}
                          </div>
                        )}
                        tagRender={(props) => {
                          const { label, closable, onClose } = props;
                          return (
                            <span
                              style={{
                                background: '#f6ffed',
                                border: '1px solid #b7eb8f',
                                borderRadius: '8px',
                                padding: '2px 8px',
                                margin: '2px',
                                display: 'inline-block',
                                color: '#52c41a',
                              }}
                            >
                              {label}
                              {closable && (
                                <span
                                  style={{
                                    marginLeft: '4px',
                                    cursor: 'pointer',
                                    color: '#999',
                                  }}
                                  onClick={onClose}
                                >
                                  ×
                                </span>
                              )}
                            </span>
                          );
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col lg={8} md={24} sm={24} xs={24}>
                    <Form.Item label="Status" name="status">
                      <Select
                        mode="multiple"
                        name="status"
                        showSearch
                        options={[
                          { value: "all", label: "All" },
                          { value: "pending", label: "Pending" },
                          { value: "extracted", label: "Extracted" },
                          { value: "success", label: "Success" },
                          { value: "failed", label: "Failed" },
                          { value: "deleted", label: "Deleted" },
                          { value: "submitted", label: "Submitted" },
                          { value: "failed-submittable", label: "Failed Submittable" },
                          { value: "duplicate", label: "Duplicate" },
                          { value: "canceled", label: "Cancelled" },
                          { value: "on hold", label: "On Hold" }
                        ]}
                        size="large"
                        placeholder="Select Multiple Status"
                        listHeight={200}
                        maxTagCount="responsive"
                        allowClear
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          (option?.label ?? "").toString().toLowerCase().includes(input.toLowerCase())
                        }
                        optionRender={(option) => (
                          <div style={{ whiteSpace: "normal", lineHeight: "1.2em", overflowWrap: "break-word" }}>
                            {option.data.label}
                          </div>
                        )}
                        tagRender={(props) => {
                          const { label, closable, onClose } = props;
                          return (
                            <span
                              style={{
                                background: '#e6f7ff',
                                border: '1px solid #91d5ff',
                                borderRadius: '10px',
                                padding: '2px 8px',
                                margin: '2px',
                                display: 'inline-block',
                                color: '#1890ff',
                              }}
                            >
                              {label}
                              {closable && (
                                <span
                                  style={{
                                    marginLeft: '4px',
                                    cursor: 'pointer',
                                    color: '#999',
                                  }}
                                  onClick={onClose}
                                >
                                  ×
                                </span>
                              )}
                            </span>
                          );
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col lg={8} md={24} sm={24} xs={24}>
                    <Form.Item label="Format Type" name="formatType">
                      <Select
                        mode="multiple"
                        name="formatType"
                        showSearch
                        options={[
                          { value: "all", label: "All" },
                          { value: "PDF", label: "PDF" },
                          { value: "Excel", label: "Excel" }
                        ]}
                        size="large"
                        placeholder="Select Multiple Formats"
                        listHeight={200}
                        maxTagCount="responsive"
                        allowClear
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          (option?.label ?? "").toString().toLowerCase().includes(input.toLowerCase())
                        }
                        optionRender={(option) => (
                          <div style={{ whiteSpace: "normal", lineHeight: "1.2em", overflowWrap: "break-word" }}>
                            {option.data.label}
                          </div>
                        )}
                        tagRender={(props) => {
                          const { label, closable, onClose } = props;
                          return (
                            <span
                              style={{
                                background: '#fff7e6',
                                border: '1px solid #ffd591',
                                borderRadius: '8px',
                                padding: '2px 8px',
                                margin: '2px',
                                display: 'inline-block',
                                color: '#fa8c16',
                              }}
                            >
                              {label}
                              {closable && (
                                <span
                                  style={{
                                    marginLeft: '4px',
                                    cursor: 'pointer',
                                    color: '#999',
                                  }}
                                  onClick={onClose}
                                >
                                  ×
                                </span>
                              )}
                            </span>
                          );
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row justify="center" gutter={16}>
                  <Col>
                    <Button size="large" onClick={handleFormClear}>
                      Clear
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      size="large"
                      type="primary"
                       htmlType="submit">
                      Search
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
            <Divider />

            <Flex gap={16} justify="space-between" align="center" style={{ marginBottom: '16px' }}>
              <Flex gap={16}>
                <Alert
                  message={`${accountSearchData.length} Total Number of Documents`}
                  type="success"
                  showIcon
                  style={{ width: 'fit-content' }}
                />
                
                <Alert
              message={`${selectedRows.length} Documents Selected (Click to Clear)`}
              type="info"
              showIcon
              style={{ 
                width: 'fit-content', 
                marginBottom: '16px', 
                cursor: 'pointer'  //make it look clickable
              }}
              onClick={() => {
                setSelectedRowKeys([]);   //clear selection keys
                setSelectedRows([]);      //clear selection rows
              }}
            />
              </Flex>
              
              <Flex gap={14}>
                <Button onClick={() => shareDocumentDrawer(null)}
                  disabled={!isShareBtnDisable}>
                  <Space>
                    Share
                  </Space>
                </Button>
                
                <Dropdown disabled={selectedRows.length === 0} menu={{ items: menuItems }} className="download-btn">
                  <Button>
                    <Space>
                      Download
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              </Flex>
            </Flex>
            
             <div
              style={{
                maxWidth: '100%', // Ensure the container doesn't exceed its width
                overflowX: 'auto', // Enable horizontal scroll
              }}
            >
            <Table
              dataSource={accountSearchData}
              components={{
                header: {
                  cell: ResizableTitle, 
                },
              }}
              columns={mergedColumns}
              locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description='No records found!'/> }}
              size="small"
              rowSelection={{
                selectedRowKeys,
                onChange: handleSelectChange,
              }}
            />
            </div>
            <br />

          </Card>
        </div>


      </Col>
      <ViewDocument ref={viewDocumentRef} />
      <StatusTrial ref={statusTrialRef} />
      <ShareDocument ref={shareDocumentRef} />


    </Row>
  );
}
